// src/components/PageForm.jsx
import React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { XCircle, PlusCircle } from "lucide-react";

export default function PageForm({
  mode,
  defaultValues = {},
  onSubmit,
  onCancel,
  submissionLoading = false,
}) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      trigger_text: defaultValues.trigger_text || [{ text: "" }],
      mode,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "trigger_text",
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      {/* Trigger Texts */}
      <div>
        <label className="block text-sm font-medium mb-1">Trigger Texts</label>
        {fields.map((field, index) => (
          <div key={field.id} className="flex items-center mb-2 space-x-2">
            <input
              {...register(`trigger_text.${index}.text`)}
              readOnly={mode === "view"}
              placeholder="Enter trigger text"
              className="flex-1 py-2 px-3 border rounded"
            />
            {mode !== "view" && (
              <button
                type="button"
                onClick={() => remove(index)}
                className="text-red-500 hover:text-red-700"
                title="Remove trigger text"
              >
                <XCircle size={20} />
              </button>
            )}
          </div>
        ))}
        {mode !== "view" && (
          <button
            type="button"
            onClick={() => append({ text: "", admin_added : true })}
            className="flex items-center text-primary hover:text-primary-dark"
          >
            <PlusCircle className="mr-1" />
            Add Trigger Text
          </button>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-3 pt-4 border-t">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border rounded text-gray-700"
        >
          {mode === "view" ? "Close" : "Cancel"}
        </button>
        {mode !== "view" && (
          <button
            type="submit"
            disabled={submissionLoading}
            className="px-4 py-2 bg-primary text-white rounded flex items-center justify-center gap-2"
          >
            {submissionLoading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                  ></path>
                </svg>
                <span>Loading...</span>
              </>
            ) : (
              <>{mode === "edit" ? "Save Changes" : "Create Trigger"}</>
            )}
          </button>
        )}
      </div>
    </form>
  );
}
